import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-delete-venue',
  templateUrl: './delete-venue.component.html',
})
export class DeleteVenueComponent implements OnInit {

  closeReason: 'success' | 'cancel';

  constructor(private bsModalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  public confirmDelete(){
    this.onDismiss('success');
  }

  public onDismiss(reason: 'success' | 'cancel'){
      this.closeReason = reason;
      this.bsModalRef.hide();
  }

}
